import React from "react";
import ButtonGroupNavigation from "components/button_group_navigation";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Switch, Route } from "react-router-dom";
import Setup from "./Setup";

const useStyles = makeStyles((theme) => ({
  subNavigation: {
    padding: "1rem 0rem 0rem 2rem",
    width: "100%",
  },
}));

export default function Admin(props) {
  const classes = useStyles();
  const buttons = [{ name: "Setup", redirect: "/org/reports/admin/setup" }];
  return (
    <div>
      <div className={classes.subNavigation}>
        <ButtonGroupNavigation buttons={buttons} {...props} />
      </div>
      <Switch>
        <Route
          exact
          path={"/org/reports/admin/setup"}
          component={(rprops) => <Setup {...rprops} {...props} />}
          permission={props?.permission}
        />
        <Route component={Setup} />
      </Switch>
    </div>
  );
}
